import { useTranslation } from 'react-i18next';
import { Modal, Tag } from 'antd';
import { STATUS_COLORS } from '../../_shared/constants';
import { formatDuration } from '../../_shared/utils';

const STATUS_I18N_MAP = {
  OPEN: 'taskStatusOpen',
  IN_PROGRESS: 'taskStatusInProgress',
  DONE: 'taskStatusDone',
};

export default function TaskDetailModal({
  open,
  onClose,
  task,
  canManage = false,
}) {
  const { t } = useTranslation(['forms']);

  if (!task) return null;

  const assigneeNames =
    task.assignees
      ?.map((a) => `${a.firstName || ''} ${a.lastName || ''}`.trim())
      .filter(Boolean)
      .join(', ') || '-';

  return (
    <Modal
      title={task.name}
      open={open}
      onCancel={onClose}
      footer={null}
      width={480}
    >
      <div className="flex flex-col gap-3 py-2">
        {task.description && (
          <div>
            <span className="text-xs font-medium text-gray-400">
              {t('description', { ns: 'forms' })}
            </span>
            <p className="mt-1 whitespace-pre-wrap text-sm">{task.description}</p>
          </div>
        )}

        <div className="flex gap-6">
          <div>
            <span className="text-xs font-medium text-gray-400">
              {t('status', { ns: 'forms' })}
            </span>
            <div className="mt-1">
              <Tag color={STATUS_COLORS[task.status]}>
                {t(STATUS_I18N_MAP[task.status], { ns: 'forms' })}
              </Tag>
            </div>
          </div>

          {task.estimatedHours != null && (
            <div>
              <span className="text-xs font-medium text-gray-400">
                {t('estimatedHours', { ns: 'forms' })}
              </span>
              <p className="mt-1 text-sm">
                {formatDuration(task.estimatedHours * 60)}
              </p>
            </div>
          )}
        </div>

        <div>
          <span className="text-xs font-medium text-gray-400">
            {t('assignees', { ns: 'forms' })}
          </span>
          <p className="mt-1 text-sm">{assigneeNames}</p>
        </div>

        {canManage && (
          <div className="flex gap-6">
            <div>
              <span className="text-xs font-medium text-gray-400">
                {t('billable', { ns: 'forms' })}
              </span>
              <p className="mt-1 text-sm">
                {task.billable == null
                  ? '-'
                  : task.billable
                    ? t('yes', { ns: 'forms' })
                    : t('no', { ns: 'forms' })}
              </p>
            </div>

            {task.hourlyRate != null && (
              <div>
                <span className="text-xs font-medium text-gray-400">
                  {t('hourlyRate', { ns: 'forms' })}
                </span>
                <p className="mt-1 text-sm">{task.hourlyRate}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}
